import React, { useRef, useState, useEffect } from "react";
import { Box, Card, CardContent, IconButton, LinearProgress, Typography, useTheme } from "@mui/material";
import { LocalFireDepartment, Scoreboard } from "@mui/icons-material";
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { httpEndpoint } from "../services/backend";
// import AnimatedNumbersRaw from "react-animated-numbers";
import TextTransition, { presets } from "react-text-transition";
import { AppSingleton } from "../services/user_config";
import { accuracyToRank, getReminders } from "../utils/PoseUitils";
import { getAdaptivFontSize } from "../utils/CommonUtils";
import { getOrientation } from "../utils/CommonUtils";

const ScoreComponent = ({
  videoDuration,
  videoCurrentTime,
  gestureStatusRef,
  scoreRef,
  backfeedScore,
  backfeedAccuracy,
  isReadyRef,
}) => {
  const [score, setScore] = useState(0.0);
  const [scoreInt, setScoreInt] = useState(0);
  const [accuracy, setAccuracy] = useState(0.5);
  const [orientation, setOrientation] = useState(getOrientation()); // MARK: portrait, landscape
  // const [accuracyInt, setAccuracyInt] = useState(50);
  const scoreFactor = 2.0;
  const appSingleton = new AppSingleton();
  const contentColor = appSingleton.isDarkMode ? "white" : "black";
  const theme = useTheme();

  const onScreenResize = () => {
    setOrientation(getOrientation());
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (gestureStatusRef.current && videoDuration > 0.0 && isReadyRef.current) {
        const _reminders = getReminders(gestureStatusRef.current);
        // const scoreDelta = (1 / (_reminders.length + 1)) * scoreFactor;
        // console.log(`scoreDelta: ${scoreDelta}`);
        // setScore((prevScore) => {
        //   return prevScore + scoreDelta;
        // });
        const totalScore = Object.values(scoreRef.current).reduce((acc, val) => acc + val, 0);
        setScore(totalScore);
        // console.log(`totalScore: ${totalScore}`);
        setAccuracy((prevAccuracy) => {
          // return Math.min(prevAccuracy - (_reminders.length - 1) / 100.0, 100.0);
          return totalScore / Object.keys(scoreRef.current).length / 2;
        });
        // console.log(`accuracy: ${totalScore / Object.keys(scoreRef.current).length / 2}`);
      }
    }, 1000);

    window.addEventListener("resize", onScreenResize);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", onScreenResize);
    };
  }, [videoDuration]);

  useEffect(() => {
    const _score = Math.floor(score);
    setScoreInt((prevScoreInt) => {
      return _score;
    });
    backfeedScore(_score);
  }, [score]);

  useEffect(() => {
    // const _accuracy = Math.floor(accuracy);
    // setAccuracyInt((prevAccuracyInt) => {
    //   return _accuracy;
    // });
    backfeedAccuracy(accuracy);
    // console.log(`accuracy: ${Math.floor(accuracy)}`);
  }, [accuracy]);

  return (
    <Box sx={{ width: "100%" }}>
      <Card
        sx={{
          // backgroundColor: "#cccccc",
          borderTopLeftRadius: "32px",
          borderTopRightRadius: "32px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          boxShadow: "2px -4px 4px 1px rgba(64, 64, 64, 0.6)" /* offset-x | offset-y | blur-radius | spread-radius | color */,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              // alignItems: "flex-end",
              // alignItems: "center",
              height: `${orientation === "landscape" ? 90 : 180}px`,
            }}
          >
            <Box sx={{ mb: 4, ml: window.screen.width < 768 ? 1 : 4 }}>
              <Typography variant="span">
                <IconButton disabled={true} style={{ color: "red" }} sx={{ fontSize: getAdaptivFontSize(48) }}>
                  <LocalFireDepartment />
                </IconButton>
              </Typography>
              <Typography
                color="primary"
                variant="span"
                sx={{
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                }}
              >
                A.I.評分
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <TextTransition
                  springConfig={presets.wobbly}
                  style={{
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? 16 : 32),
                    color: { contentColor },
                  }}
                >
                  {/* {`${Math.floor(accuracyInt)}%`} */}
                  {`${accuracyToRank(accuracy)}`}
                </TextTransition>
              </Box>
            </Box>
            <Box sx={{ mb: 4, mr: window.screen.width < 768 ? 1 : 4 }}>
              <Typography variant="span">
                <IconButton disabled={true} style={{ color: "red" }} sx={{ fontSize: getAdaptivFontSize(48) }}>
                  <Scoreboard />
                </IconButton>
              </Typography>
              <Typography
                variant="span"
                color="primary"
                sx={{
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                }}
              >
                得分
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "right" }}>
                <TextTransition
                  springConfig={presets.wobbly}
                  style={{
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? 16 : 32),
                    color: { contentColor },
                  }}
                >
                  {scoreInt}
                </TextTransition>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Box
        sx={{
          position: "fixed",
          left: `calc(${(videoCurrentTime / videoDuration) * 100.0}% - 48px)`,
          bottom: -16,
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <img
          src={`/img/running.gif`}
          alt="🏃"
          style={{
            width: "96px",
            height: "96px",
            objectFit: "cover",
          }}
        />
      </Box>
      <LinearProgress
        variant="buffer"
        // color="white"
        value={(videoCurrentTime / videoDuration) * 100}
        valueBuffer={(1 - videoCurrentTime) / videoDuration}
      />
    </Box>
  );
};

export { ScoreComponent };
